import { cn } from '@antimatterhq/ui/lib/utils';

export type EditableChipPipeAddonProps = {
  width: number;
  className?: string;
  onDragStart?: (e: React.DragEvent) => void;
  onDragEnd?: (e: React.DragEvent) => void;
};

export const EditableChipPipeAddon = ({
  width,
  className,
  onDragStart,
  onDragEnd,
}: EditableChipPipeAddonProps) => {
  return (
    <div
      className={cn(
        'cursor-grab text-right text-gray-600 dark:text-gray-400',
        className,
      )}
      style={{ width: `${width}px` }}
      draggable
      onDragStart={(e) => {
        e.stopPropagation();
        onDragStart?.(e);
      }}
      onDragEnd={(e) => {
        e.stopPropagation();
        onDragEnd?.(e);
      }}
    >
      {'|>'}
    </div>
  );
};
